import { Component, Input, OnInit } from '@angular/core';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { WorkFlow } from '../masterdata/models/workFlow';
import { MessagesService } from '../messages/messages.service';
import { Plate } from '../models/plate';
import { Sample } from '../models/sample';
import { Step } from '../models/step';
import { Storage } from './../../app/models/storage';
import { ErrorHandler } from '../utils/error-handler';
import { ArrayProject } from '../masterdata/models/arrayProject';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { CommentDTO } from '../ma-comments-popup/comment-dto';
import { AnnouncedService } from '../apg-announced/services/announced.service';
import { SamplePlateHistoryDTO } from '../models/samplePlateHistoryDTO';
import { SampleCommentDTO } from '../models/sampleCommentDTO';
import { PlateStatus, PlateType, ProcessStep, ProcessUpdateStage } from '../models/process-step';
import { ApgDeliveryService } from '../apg-delivery/apg-delivery.service';
import { MaStorageService } from '../ma-storage/ma-storage.service';
import { SearchDelivery } from '../models/searchDelivery';
import { StoragePlateDTO } from '../models/storagePlateDTO';
import { Comment } from '../models/comment';
import { saveAs as saveByFileSaver } from "file-saver";
import { priorityMap } from '../utils/priority-row';
import { ProcessUpdateDTO, SampleData } from '../models/wb-process-update';
import { SampleRedoDownloadDTO } from '../models/sampleRedoDownloadDTO';
import { StepAction } from '../models/step-action';
import { Action } from '../models/action';
import {showLatestComment} from "../utils/latest-comment-util";
import { formatDate, DatePipe } from "@angular/common";
import prepareRemoveSampleDTO from "../utils/remove-sample-util";
import { PlateListDTO } from '../dto/plateListDTO';

@Component({
  selector: 'app-icbf-workflow',
  templateUrl: './icbf-workflow.component.html',
  styleUrls: ['./icbf-workflow.component.css']
})
export class ICBFWorkflowComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  readonly showLatestComment = showLatestComment;
  loading: boolean;
  blocked: boolean;
  selectedLabId: string;
  selectedWorkFlow: WorkFlow;
  puid: string;
  plateToSearch: string = "";
  sampleToSearch: string = "";
  mapOfSenders = new Map();
  customerList: any[] = [];
  selectedSender: SenderDTO;

  plates: Plate[] = []
  selectedPlate: Plate;
  selectedPlateStepsMap: Map<string, Step>;
  plate: Plate;
  selectedSample: Sample = new Sample();

  scannedBarcodeToShow: string = "";

  selectedTabIndex: number = 0;
  projectData: ArrayProject[] = [];
  projectsList = [];
  plateTypeOptionList = [{label: PlateType.STANDARD, value: PlateType.STANDARD}, {label: PlateType.STORAGE, value: PlateType.STORAGE}, {label: PlateType.REDO, value: PlateType.REDO}];
  sampleTypeList = [];
  storageList =[];
  plateSamplesMap= new Map();
  sampleBarcodeMap = new Map();

  selectedStorage: Storage;
  beadchipSamplesMap: Map<string, Map<string, Sample>> = new Map();
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  BcolumnHeaders=["C01","C02","C03"];
  BrowHeaders=['R01','R02','R03','R04','R05','R06','R07','R08','R09','R10','R11','R12','R13','R14','R15','R16'];


  @Input() selectedProcessFlows: ProcessFlow[];
  selectedProject: ArrayProject;
  selectedCell: string = 'A1';
  scannedBarcode: string = '';
  plateComment: string = '';
  showSampleCheckFailedDialog: boolean = false;
  sampleCheckErrorMessage: string = '';
  showCommentsDialog: boolean = false;
  selectedPlateHistory: SamplePlateHistoryDTO[] = [];
  receivedSamplesInPlateMap = new Map();
  newComment: string = '';
  commentsDisplayMap:Map<string, boolean> = new Map();
  commentList: SampleCommentDTO[] = [];
  @Input() isSampleScan: boolean;
  @Input() scannedPlateID: string;
  boxflag: boolean = false;
  boxReceptionTimeStamp: Date;
  selectedBoxID: any;
  boxStatus: any;
  storageActivate: boolean = false;
  samplePresentErrorMessage: string;
  showSamplePresentDialog: boolean = false;
  storageLocationList: Array<any>;
  showStorageDialog: boolean;
  selectedStorageList: any;
  selectedPlateStorage: any;
  statusdata: string;
  processStartedvalue: boolean;
  sampleData: Sample = new Sample()
  placeAnnouncedSampletoStorage: boolean = false;
  reProcessed: boolean = false;
  selectedPickedSample: Sample = new Sample();
  duplicateSamplesPopUpNormalPlate: boolean = false;
  duplicateSamplesPopUpStoragePlate: boolean = false;
  duplicateSamplesPresent: boolean = false;
  allSelectedSamples: any[] = [];
  removeSamples: boolean = false;
  unsuitableDialog: boolean = false;
  enteredSampleId: String = "";
  sampleIDList: String[] = [];
  barcodeIDMap: Map<String, String> = new Map();
  barcodePositionMap: Map<String, String> = new Map();
  positionBarcodeMap: Map<String, String> = new Map();
  sampleList: String[] = [];
  samplePositionList: String[] = [];
  existingPositions: String[] = [];
  showPlateNotFilledUpPopup: boolean = false;
  boxEmptyPopup: boolean = false;
  checkBoxEmpty: boolean = false;
  boxProjectID: any;
  selectedSampleType: any;
  selectedPlateType: any = PlateType.STANDARD;
  tableSelectedRow: Plate;
  selectedPlateSampleType: string;
  disableSampleType : boolean = false;
  fetchedCommentsPlate: Plate;
  showCommentDialog: boolean = false
  selectedPlateID: string = ''
  selectedPlateStatus: string = ""
  plateCommentsList: Comment[] = [];
  isBarcodeNotReadableChecked: boolean  = false
  receptionRedoList: Array<string> = [];
  selectedRedoReason:any
  multiUnsuitableSampleList: Array<any> = [];
  disableSampleInput: boolean = false;
  disableUpdateButton: boolean = true;
  enteredUnsuitableSampleId:string = ''
  duplicateSampleForUnsuitable: boolean = false
  beadChipCommentsMap :Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap:Map<string, boolean> = new Map<string, boolean>();
  showPlatePriority = false
  filterOptions: any[];
  selectedStatuses: string[] = [];
  statusFilterList = [PlateStatus.PLATE_CREATED, PlateStatus.RECEPTION_COMPLETED];
  weatherbySampleDataList: Array<SampleData> = []
  isProcessUpdateProxied : boolean;
  numberOfRedoSamples: number = null;

  showDueDate = false;

  constructor(
      private readonly masterDataService: MasterDataService,
      private readonly announcementService:AnnouncedService,
      private readonly _messagesService: MessagesService,
      private readonly platePreparationService: MaPlatePreparationService,
      private readonly deliveryService: ApgDeliveryService,
      private readonly _maStorageService: MaStorageService,
      private readonly datePipe:DatePipe
  ) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedPlate = new Plate();
    this.selectedPlate.samples = [];
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.selectedWorkFlow = JSON.parse(localStorage.getItem('selectedWorkFlow'));
    this.onApplyFilter();
    this.isProcessUpdateProxied = this.selectedWorkFlow.proxyWeatherbyAPI

    this.selectedPlateStepsMap = new Map();

    this.masterDataService.getConfigList(this.selectedLabId, "arrayProject", 0, 100, true).subscribe({
      next: (results) => {
        this.projectData = results.data;
        this.projectsList = [];
        this.projectData.forEach(project => {
          this.projectsList.push({label: project.projectID, value: project})
        })
      },
      error: (error) => {
        this.showError(error);
      }
  })

    this.getSampleTypefromMDM()
    this.getRedoSampleCount();
    this.storageLocationList = [];
    this._maStorageService.fetchActiveStorageLocations(this.selectedLabId).subscribe({
      next: (result) => {
        this.storageLocationList = result.datalist;
        this.storageList = [];
        this.storageLocationList.forEach(storagelist => {
          this.storageList.push({label : storagelist.storageName, value : storagelist.storageName})
        })
      }
  })

    this.masterDataService.getReceptionIssueRedos(this.selectedLabId).subscribe({
      next: (result) => {
        this.receptionRedoList = result.data;
      },
      error: (err) => {
        this.showError(err);
      }
    });

    if(this.scannedPlateID) {
      this.searchForPlateAction(this.scannedPlateID);
      this.scannedPlateID = null;
    }

    this.filterOptions = [
      { label: 'Plate Created', value: PlateStatus.PLATE_CREATED },
      { label: 'Announced', value: PlateStatus.ANNOUNCED },
      { label: 'Received', value: PlateStatus.RECEIVED },
      { label: 'Reception Completed', value: PlateStatus.RECEPTION_COMPLETED}
    ];
  }
  getSampleTypefromMDM() {
    this.sampleTypeList = [];
    this.selectedProcessFlows.forEach(processFlow => {
      let sampletypes = processFlow.sampleType.split(",").map(item => item.trim());
      sampletypes.forEach(sampletype=>{
        this.sampleTypeList.push({label:sampletype, value: sampletype})
      })

    });
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  onApplyFilter(){
    let queryStatusList = this.selectedStatuses.join(',');
    this.getAnnounedPlates(queryStatusList);
  }

  preparePlateSearchDTO(labId: string, type: string, status?: string, fromDate?: Date, toDate?: Date, selectedProjects?: string, selectedProtocolWorkflows?: string): PlateListDTO {
    const plateListDTO = new PlateListDTO();
    plateListDTO.labId = labId;
    if (typeof type !== 'undefined') {
      plateListDTO.type = type;
    }
    if (typeof status !== 'undefined') {
      plateListDTO.status = status;
    }
    if (fromDate !== undefined && fromDate !== null) {
      plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US');
    }
    if (toDate !== undefined && toDate !== null) {
      plateListDTO.toDate = formatDate(toDate, 'yyyy-MM-dd', 'en-US');
    }
    if (typeof selectedProjects !== 'undefined' && selectedProjects.trim() !== "") {
      plateListDTO.selectedProjects = selectedProjects;
    }
    if (typeof selectedProtocolWorkflows !== 'undefined' && selectedProtocolWorkflows.trim() !== "") {
      plateListDTO.selectedProtocolWorkflows = selectedProtocolWorkflows;
    }
    return plateListDTO;
  }

  getAnnounedPlates(status?: string) {
    this.loading = true;
    if(status === '' || status == undefined){
        status = this.statusFilterList.join(',');
    }
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "PLATE",status)).subscribe({
        next:(result) => {
            this.loading = false;
            this.plates = result;
            if(this.selectedPlate.plateID != null){
                for(let i=0; i<this.plates.length; i++){
                    if(this.selectedPlate.plateID == this.plates[i].plateID){
                        this.tableSelectedRow = this.plates[i];
                        break;
                    }
                }
            }
        },
        error: (error) => {
            this.loading = false;
            console.log("Error in fetching received plates ", error);
            this._messagesService.addErrorMessage({
                severity: 'error', summary: 'Failed to fetch plates',
                detail: 'Some issue in pulling the plates info, please try again'
            });
        }
    });
  }

  setAction(actionStep: string): StepAction{
    let stepAction: StepAction = {
      action: actionStep,
      actionStartTime: new Date(),
      actionRunTime: 0,
      actionPUID: this.puid,
      chemicals: []
    }
    return stepAction;
  }

  setActionForProcessStep(step: string, processFlow: ProcessFlow): StepAction[]{
    let action: StepAction[] = [];
    if(step === ProcessStep.LYSIS){
      if(processFlow.okTOpureHair){
        action.push(this.setAction(Action.INCUBATE_56C),this.setAction(Action.STOP_INCUBATION_56C));
      }else if(processFlow.okTOpureEartag){
        action.push(this.setAction(Action.INCUBATE_56C_1H),this.setAction(Action.STOP_INCUBATION_56C_1H),this.setAction(Action.INCUBATE_56C_ON),this.setAction(Action.STOP_INCUBATION_56C_ON),this.setAction(Action.INCUBATE_56C_2H),this.setAction(Action.STOP_INCUBATION_56C_2H));
      }
    }else if(step === ProcessStep.EXTRACTION){
      if(processFlow.okTOpureEartag){
        action.push(this.setAction(Action.INCUBATE_56C_R),this.setAction(Action.STOP_INCUBATION_56C_R),this.setAction(Action.TRANSFER_LYSIS), this.setAction(Action.PREPARE_OKTOPURE))
      }else if(processFlow.okTOpureHair){
        action.push(this.setAction(Action.TRANSFER_LYSIS), this.setAction(Action.PREPARE_OKTOPURE))
      }else if(processFlow.ExEartagTLR){
        action.push(this.setAction(Action.INCUBATE_65C), this.setAction(Action.STOP_INCUBATION_65C), this.setAction(Action.INCUBATE_98C), this.setAction(Action.STOP_INCUBATION_98C))
      }
    }
    return action;
  }

  setProcessStepForPlate(step: string, processFlow: ProcessFlow): Step{
    let processStep :Step = {
      step : step,
      startPUID : this.puid,
      startTimeStamp: new Date(),
      endTimeStamp: new Date(),
      endPUID : this.puid,
      action: this.setActionForProcessStep(step, processFlow),
      liquidHandler : "",
      endLiquidHandler: "",
      chemicals: []
    }
    return processStep;
  }

  createBatch(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.selectedPlate.sender = this.selectedProject.sender;
    this.selectedPlate.workFlow = this.selectedProject.workflow;
    this.selectedPlate.storagePlate = this.selectedPlateType === PlateType.STORAGE;

    this.selectedPlate.labID = this.selectedLabId;
    this.selectedPlate.sampleType = this.selectedSampleType;
    let sampleProcessFlow: ProcessFlow = new ProcessFlow();
    this.selectedProcessFlows.forEach(processFlow =>{
      let sampletypeList = processFlow.sampleType.split(",").map(item => item.trim());
      if(sampletypeList.includes(this.selectedPlate.sampleType)){
        this.selectedPlate.processFlowName  = processFlow.processFlowName;
        sampleProcessFlow = processFlow;
      }
    });
    if(this.selectedPlateType == PlateType.REDO){
      this.selectedPlate.status = PlateStatus.EXTRACTION_COMPLETED;
      let processSteps: Step[] = [];
      processSteps.push(this.setProcessStepForPlate(ProcessStep.RECEIVE_PLATE, sampleProcessFlow));
      if(sampleProcessFlow.qcScan){
        processSteps.push(this.setProcessStepForPlate(ProcessStep.QC_SCAN, sampleProcessFlow));
      }
      if(sampleProcessFlow.okTOpureEartag || sampleProcessFlow.okTOpureHair){
        processSteps.push(this.setProcessStepForPlate(ProcessStep.LYSIS, sampleProcessFlow));
      }
      processSteps.push(this.setProcessStepForPlate(ProcessStep.EXTRACTION, sampleProcessFlow));
      processSteps.push(this.setProcessStepForPlate(ProcessStep.NANODROP_PASS, sampleProcessFlow));
      this.selectedPlate.processSteps = processSteps;
    }else {
      this.selectedPlate.status = PlateStatus.PLATE_CREATED;
    }
    this.selectedPlate.lastUpdatedPlateID = this.selectedPlate.plateID
    this.selectedPlate.reRun = false
    this.selectedPlate.hasRedoSamples = false;
    this.blocked = true;
    this.platePreparationService.createPlate(this.selectedPlate).subscribe({
      next: (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.boxflag = true;
        this.onApplyFilter();
        if(this.plateComment.trim() == ""){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is created',
            detail: this.selectedPlate.plateID + ' has been created successfully!'
          });
          this.getSelectedSampleType();
          return;
        }
        this.addCommentsToPlate()
      },  error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", "summary":"Plate not created!",
          detail:"Plate not created with plate id - "+this.selectedPlate.plateID
        })
        this.clearAllFieldsForNewPlate()
      }
    })
  }

  hideDialog(){
    this.showCommentDialog = false;
    this.searchForPlateAction(this.selectedPlate.plateID);
  }

  addCommentsToPlate(disabled: boolean = false){
    if(disabled || this.plateComment === '' || this.plateComment === undefined){
      this.showComments()
      return
    }
    let updateComment = new CommentDTO();
    updateComment.platecomment = true;
    updateComment.labid = this.selectedLabId;
    updateComment.plateid = this.selectedPlate.plateID;
    updateComment.comment = this.plateComment
    updateComment.puid = this.puid;
    updateComment.status = PlateStatus.PLATE_CREATED;
    this.platePreparationService.updateComment(updateComment).subscribe({
      next: (_result) => {
        this.projectData.forEach(project => {
          if(project.sender == this.selectedPlate.sender && project.workflow == this.selectedPlate.workFlow)
            this.selectedProject = project;
        })
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is created',
          detail: this.selectedPlate.plateID + ' has been created successfully!'
        })
      },
      error: (_error) => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is created',
          detail: this.selectedPlate.plateID + ' has been created successfully!'
        })
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Plate'+this.selectedPlate.plateID+' comment not added.',
          detail: this.selectedPlate.plateID + ' plate comment not added!'
        })
      }
  })
  }

  showComments(){
    this.beadChipCommentsDisplayMap.clear();
    this.beadChipCommentsDisplayMap.set("showPlateCommentList",false)
    this.beadChipCommentsMap.clear();
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId,this.selectedPlate.plateID).subscribe({
      next: (result)=>{
        this.fetchedCommentsPlate = result;
        this.selectedPlateID = this.fetchedCommentsPlate.plateID;
        this.selectedPlateStatus = this.selectedPlate.status;
        this.plateCommentsList = this.fetchedCommentsPlate.comments;
        if(this.fetchedCommentsPlate && this.fetchedCommentsPlate.beadChips){
          this.fetchedCommentsPlate.beadChips.forEach(beadChip=>{
            this.beadChipCommentsMap.set(beadChip.beadChipID,beadChip.comments)
            this.beadChipCommentsDisplayMap.set(beadChip.beadChipID,false);
          })
        }
        this.showCommentDialog = true;
      },
      error: (error)=>{
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    })
  }

  getSelectedSampleType() {
    this.sampleTypeList = [];
    let allProcessFlowSampleTypeList = []
    let plateSampleType = this.selectedPlate.sampleType? this.selectedPlate.sampleType.split(",").map(item => item.trim())[0]: null;
    this.selectedProcessFlows.forEach(processFlow => {
      let processFlowSampleTypeList = processFlow.sampleType.split(",").map(item => item.trim())
      if(plateSampleType!= null && plateSampleType!= undefined && processFlowSampleTypeList.includes(plateSampleType)){
         processFlowSampleTypeList.forEach(element => {
          this.sampleTypeList.push({label:element,value:element});
         });
      }
      else{
        allProcessFlowSampleTypeList = allProcessFlowSampleTypeList.concat(processFlowSampleTypeList);
      }
    })
    if(allProcessFlowSampleTypeList.length > 0 && this.sampleTypeList.length === 0) {
      allProcessFlowSampleTypeList.forEach(element => {
        this.sampleTypeList.push({label:element,value:element});
      });
    }
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  disableScanningOfBarcode(){
    return this.disableScanBarcodeInput() || this.selectedPlate.processSteps?.length>=1
  }

  disableScanBarcodeInput(){
    return (this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null || !this.disableCreateBatchButton())
  }

  disableScanHorizontal(){
    return (this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null || !this.disableCreateBatchButton())
  }

  saveBarcode(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please enter USER ID before moving ahead',
      });
      return;
    }
    if(this.selectedPlate.delivery.trim() == ''){
      this._messagesService.addWarningMessage({
        severity : 'warn', summary : 'Box ID not present!',
        detail : 'Please enter a Box ID before moving ahead'
      })
      return
    }
    if(this.scannedBarcode.trim() == ''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Barcode Empty',
        detail: 'Please scan a valid barcode',
      });
      return;
    }
    this.existingPositions = []
    this.selectedPlate.samples.forEach(samp => {
      this.existingPositions.push(samp.position)
    })
    if(this.selectedPlate.storagePlate){
      this.saveBarcodeForStoragePlate();
    }else{
      this.saveBarcodeForNormalPlate();
    }
  }

  resetValues(event){
    this.duplicateSamplesPopUpNormalPlate = false;
    this.duplicateSamplesPopUpStoragePlate = false;
    this.duplicateSampleForUnsuitable = false
    this.duplicateSamplesPresent = false;
    this.blocked = false;
    this.setDuplicateSamplesPopUp()
  }

  setDuplicateSamplesPopUp(){
    this.duplicateSamplesPresent = this.duplicateSamplesPopUpNormalPlate || this.duplicateSamplesPopUpStoragePlate || this.duplicateSampleForUnsuitable
  }

  removeSamplesPopup(){
    this.removeSamples = !this.removeSamples
    this.sampleList = []
    this.sampleIDList = []
    this.samplePositionList = []
    this.barcodeIDMap = new Map();
    this.barcodePositionMap = new Map();
    this.enteredSampleId = ""
    this.selectedPlate.samples.forEach(samp => {
      this.barcodeIDMap.set(samp.sampleID, samp._id)
      this.barcodePositionMap.set(samp.sampleID, samp.position)
    })
    setTimeout(() => {
      this.findAndHighlightElement("remove-popup-sampleid");
    },500)
  }

  deleteValue(index){
    this.sampleIDList.splice(index,1);
    this.sampleList.splice(index,1);
    this.findAndHighlightElement('popup-plateid');
  }

  deleteSamples(){
    const body = prepareRemoveSampleDTO(
        this.selectedPlate,
        this.selectedLabId,
        this.samplePositionList,
        this.puid,
        this.sampleBarcodeMap
    );
    this.blocked = true;
    this.platePreparationService.removeSamples(body).subscribe({
      next: (_res_samples) => {
        this.blocked = false;
        body["sampleList"] = this.sampleIDList;
        body["resetProcessingStartDate"] = !this.selectedPlate.storage;
        this.blocked = true;
        this.announcementService.removeSamples(body).subscribe({
          next: (_res_delivery) => {
            this.blocked = false;
            this.searchForPlateAction(this.selectedPlate.plateID)
            this.removeSamples = !this.removeSamples
            this.sampleList = []
            this.sampleIDList = []
            this.samplePositionList = []
            this.enteredSampleId = ""
            this._messagesService.addSuccessMessage({
              severity: 'success',
              summary: 'Success',
              detail: "Samples successfully deleted" })
          },
          error: (_error) => {
            this.blocked = false;
          }
      })
      },
      error: (_error) =>{
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Error',
          detail: "Sample was not deleted" })
      }
  })
  }

  disableRemoveSamplesButton(){
    return !(this.sampleList.length>0)
  }

  deleteStorageSample(){
    let sampleIDList = []
    let samplePositionList = []
    samplePositionList.push(this.sampleData.plateHistory[this.sampleData.plateHistory.length-1].position)
    sampleIDList.push(this.sampleData._id)

    const comment = new SampleCommentDTO();
		comment.comment = "sample scanned in " + this.selectedPlate.plateID;
		comment.puid = this.puid;
		comment.status = "SAMPLE_RECEPTION";

    let body = {
      "samplePositionList":samplePositionList,
      "labID":this.selectedLabId,
      "plateID":this.sampleData.plateHistory[this.sampleData.plateHistory.length-1].plateId,
      "comment": comment
    }
    this.blocked = true;
    this.platePreparationService.removeSamples(body).subscribe({
      next: (res_samples) => {
        this.blocked = false;
        if(res_samples.includes("Samples deleted successfully")){
          this._messagesService.addInfoMessage({
            severity: 'info', summary: 'Sample in storage',
            detail: `Sample ${this.scannedBarcode} removed from the storage plate`,
          })
          body["sampleList"] = sampleIDList;
          body["resetProcessingStartDate"] = !this.selectedPlate.storage
          this.blocked = true;
          this.announcementService.removeSamples(body).subscribe({
            next: (res_delivery) => {
              this.blocked = false;
              this.sampleList = []
              this.sampleIDList = []
              this.samplePositionList = []
              this.enteredSampleId = ""
            },
            error: (_error) => {
              this.blocked = false;
            }
        })
        }
      },
      error: (error) =>{
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Error',
          detail: "Sample was not deleted" })
      }
  })
  }

  checkSample(){
    if(this.barcodeIDMap.has(this.enteredSampleId)){
      this.sampleList.push(this.enteredSampleId)
      //For samples processing service
      this.sampleIDList.push(this.barcodeIDMap.get(this.enteredSampleId))

      //For delivery service
      this.samplePositionList.push(this.barcodePositionMap.get(this.enteredSampleId))

      this.enteredSampleId = ""
    }
    else{
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Barcode not present in Plate',
        detail: "Barcode not present in Plate",
      })
      this.enteredSampleId = ""
    }
  }

  selectedSampleFromScan(sample){
    const sampleId = this.unsuitableDialog ? this.enteredUnsuitableSampleId : this.scannedBarcode
    this.announcementService.putBarcodeInSample(sampleId, sample).subscribe({
      next: (result) => {
        this.blocked = false;
        this.selectedPickedSample = result.data
        if(this.duplicateSamplesPopUpNormalPlate){
          this.saveBarcodeForNormalPlateAfterDuplicateSelection(this.selectedPickedSample)
        }
        else if(this.duplicateSamplesPopUpStoragePlate){
          this.saveBarcodeForStoragePlateAfterDuplicateSelection(this.selectedPickedSample)
        }
        else{
          this.addDuplicateSampleToList(this.selectedPickedSample._id)
        }
      },
     error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", summary:"Encountered error fetching Sample "+this.scannedBarcode,
          detail: error
        });
      }
    });
  }

  saveBarcodeForNormalPlateAfterDuplicateSelection(sample){
    this.sampleData = sample
    let flagSampleExists = false
    this.selectedPlate.samples.forEach(res => {
      if(res.sampleID == sample.barCode){
        this._messagesService.addErrorMessage({
          severity: 'error', summary:"Sample Not Added!",
          detail: "Sample already exists"
        })
        flagSampleExists = true
      }
    })
    if(flagSampleExists){
      this.setDuplicateSamplesPopUp()
      return
    }
    if(sample.receptionStatus === "REMOVED"){
      this._messagesService.addWarningMessage({
        severity:"warn",summary:"Unsuitable sample scanned",
        detail:`Sample ${this.scannedBarcode} is marked as unsuitable.`
      })
      return;
    }
    this.blocked = true;
    this.platePreparationService.checkSamplePresentInPlate(this.selectedLabId, this.sampleData._id).subscribe({
      next: (result_value)=>{
        this.blocked = false;
        if(result_value.present){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid Barcode',
            detail: "Barcode: '"+this.scannedBarcode +"' is already scanned in Plate "+ result_value.plateID +". Please scan a different barcode.",
          });
          this.sampleCheckErrorMessage = "Barcode: '"+this.scannedBarcode +"' is already scanned. Please scan a different barcode."
          return;
        }
        this.processStartedvalue = this.sampleData.storage;
        if(!sample.activated){
          this.sampleCheckErrorMessage = "Sample " + this.scannedBarcode + " is not yet activated!"
          this.showSampleCheckFailedDialog = true;
          return
        }
        this.checkIfCellIsEmptyAndAddSample(false, "duplicate");
        if(this.sampleData.storage){
          this.deleteStorageSample()
        }
      },
      error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", summary:" Sample "+this.scannedBarcode+" not Present in Storage Plate.",
          detail: error
        })
      }
  })
  }


  normalBarcodePlate(text: String){
    let newSample = this.createNewSample(this.scannedBarcode, this.selectedCell, this.sampleData.gender,this.sampleData.icbfSampleID);
    this.addSampleToPlateForDeliveryService(this.sampleData._id, this.scannedBarcode, false, true, true);
    this.blocked = true;
    this.platePreparationService.addSampleToPlate(this.selectedLabId, this.selectedPlate.plateID, newSample).subscribe({
      next: (result) => {
        this.platePreparationService.updateReProcessedToSample(this.selectedLabId, this.sampleData._id).subscribe({
          next: (_result) => {
            this.blocked = false;
          },
          error: (error) => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity:"error", summary:" Error occured in re processing a sample "+this.scannedBarcode,
              detail: error.error
            })
          }
      })
        if(text == 'duplicate'){
          this.duplicateSamplesPopUpNormalPlate = false;
          this.setDuplicateSamplesPopUp()
        }
        this.scannedBarcode = '';
        this.selectedPlate = result;
        this.sampleBarcodeMap.set(this.selectedCell,this.scannedBarcode);
        this.plateSamplesMap.set(this.selectedCell, newSample);
        if(this.selectedPlate.samples.length == 96){
          this.selectedCell = "A1"
        }
        else{
          this.incrementSelectedCell();
        }
        this._messagesService.addSuccessMessage({
          severity: 'success', summary:"Sample Added!",
          detail: "Sample "+this.scannedBarcode+" added to plate "+this.selectedPlate.plateID
        });
        this.scannedBarcode = '';
      },
      error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary:"Sample Not Added!",
          detail: error
        })
        this.scannedBarcode = '';
      }
  });
    this.findAndHighlightElement('barcode-scanner');
  }


  saveBarcodeForStoragePlateAfterDuplicateSelection(sample){
    this.sampleData = sample
    if ((sample.activated && sample.announced && this.selectedPlate.storagePlate) && !this.placeAnnouncedSampletoStorage) {
      this.samplePresentErrorMessage = "Sample " + this.scannedBarcode + " is announced in the customer manifest and also activated!"
      this.showSamplePresentDialog = true;
      return;
    }
    let flagSampleExists = false
    this.selectedPlate.samples.forEach(res => {
      if(res.sampleID == sample.barCode){
        this._messagesService.addErrorMessage({
          severity: 'error', summary:"Sample Not Added!",
          detail: "Sample already exists"
        })
        flagSampleExists = true
      }
    })
    if(flagSampleExists){
      this.setDuplicateSamplesPopUp()
      return
    }
    this.storageBarcodePlate('duplicate')
  }


  storageBarcodePlate(text: string){
    this.placeAnnouncedSampletoStorage = false;
    let newSample = this.createNewSample(this.scannedBarcode, this.selectedCell, this.sampleData.gender,this.sampleData.icbfSampleID);
    this.addSampleToPlateForDeliveryService(this.sampleData._id, this.scannedBarcode, false, true, true);
    this.blocked = true;
    this.platePreparationService.addSampleToPlate(this.selectedLabId, this.selectedPlate.plateID, newSample).subscribe({
      next: (result) => {
        this.blocked = false;
        if(text=='duplicate'){
          this.duplicateSamplesPopUpStoragePlate = false;
          this.setDuplicateSamplesPopUp()
        }
        this.selectedPlate = result;
        this.sampleBarcodeMap.set(this.selectedCell,this.scannedBarcode);
        this.plateSamplesMap.set(this.selectedCell, newSample);
        if(this.selectedPlate.samples.length == 96){
          this.selectedCell = "A1"
        }
        else{
          this.incrementSelectedCell();
        }
        this._messagesService.addSuccessMessage({
          severity: 'success', summary:"Sample Added!",
          detail: "Sample "+this.scannedBarcode+" added to plate "+this.selectedPlate.plateID
        });
        this.scannedBarcode = '';
        this.showSamplePresentDialog = false;
      },
      error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary:"Sample Not Added!",
          detail: error
        })
        this.scannedBarcode = '';
      }
  });
    this.findAndHighlightElement('barcode-scanner');
  }

  saveBarcodeAddingToNormalPlate(){
    this.blocked = true;
    this.platePreparationService.checkSamplePresentInPlate(this.selectedLabId, this.sampleData._id).subscribe({
      next: (result_value)=>{
        this.blocked = false;
        if(result_value.present){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid Barcode',
            detail: "Barcode: '"+this.scannedBarcode +"' is already scanned in Plate "+ result_value.plateID +". Please scan a different barcode.",
          });
          this.sampleCheckErrorMessage = "Barcode: '"+this.scannedBarcode +"' is already scanned. Please scan a different barcode."
          return;
        }
        this.processStartedvalue = this.sampleData.storage;
        if(!this.sampleData.activated){
          this.sampleCheckErrorMessage = "Sample " + this.scannedBarcode + " is not yet activated!"
          this.showSampleCheckFailedDialog = true;
          return;
        }
        else{
          this.normalBarcodePlate('single')
          if(this.sampleData.storage){
            this.deleteStorageSample()
          }
        }
      },
      error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", summary:" Sample "+this.scannedBarcode+" not Present in Storage Plate.",
          detail: error
        })
      }
  })

  }

  createDataForAddNewSampleInDeliveryService(commentStatus: string, approved: boolean, position: string, barcode: string = ""){
    let data = {};
    data["barCode"] = barcode === '' ? this.scannedBarcode : barcode;
    data["sampleType"] = this.selectedSampleType;
    data['announced'] = false;
    data['activated'] = false;
    data['workFlow'] = this.selectedProject.workflow;
    data['sender'] = this.selectedProject.sender;
    data['boxID'] = !this.sampleData.boxID ? this.selectedPlate.delivery : this.sampleData.boxID;
    data['boxReceptionTimeStamp'] = !this.sampleData.boxReceptionTimeStamp ? this.boxReceptionTimeStamp : this.convertToDate(this.sampleData.boxReceptionTimeStamp);
    data['storage'] = this.selectedPlate.storagePlate;
    data['projectID'] = this.selectedProject.projectID
    let plateHistory = new SamplePlateHistoryDTO();
    plateHistory.approved = approved;
    plateHistory.position = position;
    plateHistory.plateId = this.selectedPlate.plateID;
    data['plateHistory'] = [plateHistory];
    let comment = new SampleCommentDTO();
    comment.comment = this.sampleCheckErrorMessage;
    comment.puid = this.puid;
    comment.status = commentStatus;
    data['comments'] = [comment]

    return data;
  }

  saveBarcodeForNormalPlate(){
    this.blocked = true;
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.scannedBarcode).subscribe({
      next: (result) => {
        this.blocked = false
        this.allSelectedSamples = result.data
        if(this.allSelectedSamples.length>1){
          this.duplicateSamplesPopUpNormalPlate = true
          this.setDuplicateSamplesPopUp()
        }
        else if(this.allSelectedSamples.length == 1){
          this.sampleData = result.data
          this.sampleData = this.sampleData[0]
          if(this.sampleData.receptionStatus === "REMOVED"){
            this._messagesService.addWarningMessage({
              severity:"warn",summary:"Unsuitable sample scanned",
              detail:`Sample ${this.scannedBarcode} is marked as unsuitable.`
            })
            return;
          }
          if(this.sampleData.receptionPUID === "SRC" && this.sampleData.processed && this.sampleData.plated ){
            this._messagesService.addWarningMessage({
              severity:"warn",summary:"SRC sample scanned",
              detail:`Sample ${this.scannedBarcode} is not eligible to be placed on plate.`
            })
            return;
          }
          this.checkIfCellIsEmptyAndAddSample(false);
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.sampleCheckErrorMessage = "Sample " + this.scannedBarcode + " was not announced in the manifest for project "+this.selectedProject.projectID
        this.showSampleCheckFailedDialog = true;
        let data = this.createDataForAddNewSampleInDeliveryService("SAMPLE_RECEPTION", false, "");
        let plateHistory = data["plateHistory"][0];
        this.blocked = true;
        this.announcementService.addSample(this.selectedLabId, this.scannedBarcode, data).subscribe({
          next: (result) => {
            this.blocked = false;
            this._messagesService.addSuccessMessage({
              severity:'success', summary:"Sample "+this.scannedBarcode+" created.",
              detail:"New Sample with sampleId "+this.scannedBarcode+" created and added."
            });
            plateHistory._id = result.data._id;
            plateHistory.sampleId = this.scannedBarcode;
            this.selectedPlateHistory.push(plateHistory);
            this.receivedSamplesInPlateMap.set(this.scannedBarcode, true);
            this.scannedBarcode = '';
          },
          error: (error: any) => {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity:"error", summary:" Sample "+this.scannedBarcode+" not created.",
              detail: error
            })
            this.scannedBarcode = '';
          }
        });
      }
    })
  }

  checkIfCellIsEmptyAndAddSample(storagePlate: boolean, sampleType: string=""){
    if(!this.existingPositions.includes(this.selectedCell)){
      if(!storagePlate){
        if(sampleType === ""){
          this.saveBarcodeAddingToNormalPlate();
        }
        else{
          this.normalBarcodePlate(sampleType);
        }
      }
      else{
        this.storageBarcodePlate(sampleType);
      }
    }
    else{
      this._messagesService.addErrorMessage({
        severity:"error", summary:"Cell is already occupied ",
        detail: "Sample already present"
      })
      if(!storagePlate && sampleType!=""){
        this.setDuplicateSamplesPopUp();
      }
    }
    return;
  }

  saveBarcodeForStoragePlate(){
    this.blocked = true;

    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.scannedBarcode).subscribe({
      next: (result) => {
        this.blocked = false;
        this.allSelectedSamples = result.data
        if (this.allSelectedSamples.length > 1) {
          this.duplicateSamplesPopUpStoragePlate = true
          this.setDuplicateSamplesPopUp()
        }
        else {
          this.sampleData = this.allSelectedSamples[0]
          if ((this.sampleData.activated && this.sampleData.announced && this.selectedPlate.storagePlate) && !this.placeAnnouncedSampletoStorage) {
            this.samplePresentErrorMessage = "Sample " + this.scannedBarcode + " is announced in the customer manifest and also activated!"
            this.showSamplePresentDialog = true;
            this.selectedPickedSample = this.sampleData;
            return;
          }
          this.blocked = true;
          this.platePreparationService.checkSamplePresentInPlate(this.selectedLabId, this.sampleData._id).subscribe({
            next: (result_sample) => {
              this.blocked = false;
              if (result_sample.present) {
                this._messagesService.addWarningMessage({
                  severity: 'warn', summary: 'Invalid Barcode',
                  detail: "Barcode: '" + this.scannedBarcode + "' is already scanned in Plate " + result_sample.plateID + ". Please scan a different barcode.",
                });
                this.sampleCheckErrorMessage = "Barcode: '" + this.scannedBarcode + "' is already scanned. Please scan a different barcode."
                return;
              }
              else {
                this.checkIfCellIsEmptyAndAddSample(true, 'storage');
              }
            },
            error: (_error) => {
              this.blocked = false;
              this.checkIfCellIsEmptyAndAddSample(true, 'storage');
            }
        })
        }
      },
       error: (error: any) => {
        this.getUnannouncedSample();
      }
    })
  }

  addSampleToPlate(newSample){
    this.platePreparationService.addSampleToPlate(this.selectedLabId, this.selectedPlate.plateID, newSample).subscribe({
      next: (result) => {
        this.selectedPlate = result;
        this.sampleBarcodeMap.set(this.selectedCell, this.scannedBarcode);
        this.plateSamplesMap.set(this.selectedCell, newSample);
        if(this.selectedPlate.samples.length == 96){
          this.selectedCell = "A1"
        }
        else{
          this.incrementSelectedCell();
        }
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: "Sample Added!",
          detail: "Sample " + this.scannedBarcode + " added to plate " + this.selectedPlate.plateID
        });
        this.scannedBarcode = '';
        this.showSamplePresentDialog = false;
      },
      error: (error) => {
        this._messagesService.addErrorMessage({
          severity: 'error', summary: "Sample Not Added!",
          detail: error
        })
        this.scannedBarcode = '';
      }
  });
  }

  getUnannouncedSample(){
    this.createNewUnannoucedSample('', this.selectedCell, true, (_new_sample) => {
      this.announcementService.getSampleFromDelivery(this.selectedLabId, this.scannedBarcode).subscribe({
        next: (result) => {
          this.sampleData = result.data[0]
          let newSample = this.createNewSample(this.scannedBarcode, this.selectedCell, this.sampleData.gender,this.sampleData.icbfSampleID);
          this.addSampleToPlate(newSample);
          this.findAndHighlightElement('barcode-scanner');
        },})
    })
  }

  createNewUnannoucedSample(barcode: string = '',position:string = '',approved:boolean,callback : (sample:any) => void){
    this.blocked = false;
    let data = this.createDataForAddNewSampleInDeliveryService("SAMPLE_STORAGE", approved, position, barcode);
    let plateHistory = data["plateHistory"];
    this.blocked = true;
    this.announcementService.addSample(this.selectedLabId, data["barCode"], data).subscribe({
     next: (result) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity:'success', summary:"Sample "+this.scannedBarcode+" created.",
          detail:"New Sample with sampleId "+this.scannedBarcode+" created and added."
        });
        plateHistory.sampleId = barcode === '' ? this.scannedBarcode : barcode;
        plateHistory._id = result.data._id
        this.selectedPlateHistory.unshift(plateHistory);
        this.receivedSamplesInPlateMap.set(barcode === '' ? this.scannedBarcode : barcode, true);
        callback(result.data)
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", summary:" Sample "+this.scannedBarcode+" not created.",
          detail: error
        })
        this.scannedBarcode = '';
      }
    })
  }

  addSampleToPlateForDeliveryService(sample_id: string, sample_barcode: string, addComment: boolean, addPlateHistory: boolean, addReceptionValues:boolean){
    let data = {}
    data['addComment'] = addComment;
    data['addPlateHistory'] = addPlateHistory;
    if(!('receptionDateTime' in this.sampleData) || this.sampleData.receptionDateTime == null){
      data['addReceptionValues'] = addReceptionValues;
    }
    else{
      data['addReceptionValues'] = false
    }

    let plateSampleTypes = this.selectedPlate.sampleType.split(",");
    let latestPlateSampleType = plateSampleTypes[plateSampleTypes.length-1];
    if(latestPlateSampleType!= this.sampleData.sampleType){
      data['addComment'] = true;
      this.sampleCheckErrorMessage =  "Sample was received as "+ this.selectedSampleType;
    }
    data['selectedSampleType'] = latestPlateSampleType;
    let comment = new SampleCommentDTO();
    comment.comment = this.sampleCheckErrorMessage;
    comment.puid = this.puid;
    comment.status = "SAMPLE_RECEPTION";
    data['comment'] = comment;

    let plateHistory = new SamplePlateHistoryDTO();
    plateHistory.plateId = this.selectedPlate.plateID;
    if(addReceptionValues){
      plateHistory.position = this.selectedCell;
      plateHistory.approved = true;
    }
    else{
      plateHistory.position = "";
      plateHistory.approved = false;
    }
    data['plateHistory']=plateHistory;
    data['puid'] = this.puid;
    data['boxID'] = !this.sampleData.boxID ? this.selectedPlate.delivery : this.sampleData.boxID;
    data['boxReceptionTimeStamp'] = !this.sampleData.boxReceptionTimeStamp ? this.boxReceptionTimeStamp : this.convertToDate(this.sampleData.boxReceptionTimeStamp);;
    data['status'] = "UNBOXED";
    if(this.processStartedvalue){
      data['processStarted'] = new Date();
    }
    data['storage'] = this.selectedPlate.storagePlate;
    data['sampleType'] = this.sampleData.sampleType
    data['projectID']=this.selectedProject.projectID

    this.blocked = true;
    this.announcementService.addSampleToPlate(this.selectedLabId, sample_id, data).subscribe({
      next: (result) => {
        this.blocked = false;
        if(result.data != null){
          plateHistory.sampleId = sample_barcode;
          plateHistory._id = sample_id
          this.selectedPlateHistory.unshift(plateHistory);
          this.receivedSamplesInPlateMap.set(sample_barcode, true);
        }
      },
      error: (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary:"Sample Update Failed",
          detail: "Sample update for plate history and comment failed!\n"+error
        })
        this.scannedBarcode = '';
      }
  })
  }

  createNewSample(barcode: string, position: string, gender: string, icbfSampleID: number){
    const newSample = new Sample();
    newSample._id = this.sampleData._id
    newSample.position = position;
    newSample.sampleID = barcode;
    newSample.beadChipID = '';
    newSample.beadChipPosition = '';
    newSample.plateRedo = false;
    newSample.priority = this.sampleData.priority
    newSample.redoBeadChipID = '';
    newSample.redoBeadChipPosition = '';
    newSample.sampleType = this.sampleData.sampleType;
    newSample.singleRedo = false;
    newSample.toBePicked = false;
    newSample.icbfSampleID = icbfSampleID;
    newSample.reRunCount = this.sampleData.reRunCount;
    newSample.autoRerun = this.sampleData.autoRerun;
    newSample.sourcePlateID = this.selectedPlate.plateID;
    newSample.sourcePlatePosition = position;
    newSample.qcSampleHistory = [];
    newSample.dueDate = this.sampleData.dueDate;
    newSample.receptionPUID = this.puid;
    newSample.mintSampleID = this.sampleData.mintSampleID
    newSample.parentMintSampleID = this.sampleData.parentMintSampleID;
    newSample.parentSampleID = this.sampleData.barCode;

    let plateSampleTypes = this.selectedPlate.sampleType.split(",");
    newSample.assignedSampleType = plateSampleTypes[plateSampleTypes.length-1];

    if(gender==="M"){
      newSample.gender = "male";
    }else if(gender=="F"){
      newSample.gender = "female";
    }
    else{
      newSample.gender = gender;
    }
    newSample.boxID = !this.sampleData.boxID ? this.selectedPlate.delivery : this.sampleData.boxID;
    if(this.selectedPlate.delivery != ""){
      newSample.boxReceptionTimeStamp = !this.sampleData.boxReceptionTimeStamp ? this.boxReceptionTimeStamp : this.convertToDate(this.sampleData.boxReceptionTimeStamp);;
    }

    if(this.selectedPlate.storagePlate){
      newSample.storage = this.selectedPlate.storagePlate;
    }
    newSample.projectID = this.sampleData.projectID
    return newSample;
  }

  incrementSelectedCell(){
    if(this.sampleBarcodeMap.size == 96){
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'All Plates Scanned',
        detail: 'All plates are scanned. Please click to complete QC Scan.'
      });
      return;
    }
    let row = this.selectedCell[0],col = Number.parseInt(this.selectedCell.substring(1)), rowDiff = 0;

    if(this.selectedPlate.scanHorizontal){
      let rowIndex
      while(true){
        rowIndex = col == this.columnHeaders[11]? this.rowHeaders.indexOf(row)+1 : this.rowHeaders.indexOf(row)
        row =  rowIndex == 8? this.rowHeaders[0] : this.rowHeaders[rowIndex]
        col = col == 12? 1 : col+1
        if(!this.sampleBarcodeMap.has(row+col)){
          this.selectedCell = row+col;
          break;
        }
      }
    }
    else{
      while(true){
        col = row ==  this.rowHeaders[7]? col+1 : col;
        col = col==13? 1 : col;
        rowDiff = row.charCodeAt(0) - 'A'.charCodeAt(0)
        row = this.rowHeaders[rowDiff==7? 0 : rowDiff+1];
        if(!this.sampleBarcodeMap.has(row+col)){
          this.selectedCell = row+col;
          break;
        }
      }
    }
  }

  updatePlate(status: string = "") {
    this.showPlateNotFilledUpPopup = false;
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.statusdata = status;
    if(status == "RECEPTION_COMPLETED" && this.selectedPlate.storagePlate){
      this.showStorageDialog = true;
    }else{
      this.updateNormalPlate(status);
    }

  }

  addDueDateToPlate() {
    let samples = this.selectedPlate.samples;
    if (samples.length == 0) {
      return null;
    }
    let minDueDate = samples[0].dueDate;
    for (let sam of samples) {
      if (sam.dueDate && sam.dueDate < minDueDate) {
        minDueDate = sam.dueDate;
      }
    }
    return minDueDate;
  }

  updateStoragePlate(statusdata, changeSelectedCell: boolean = true){
    if(statusdata != ""){
      var newStep = new Step();
      newStep.step = ProcessStep.RECEIVE_PLATE;
      newStep.startTimeStamp = new Date();
      newStep.startPUID = this.puid;
      newStep.liquidHandler = '';
      newStep.endPUID = "";
      newStep.endTimeStamp = null;
      newStep.action = [];
      newStep.chemicals = [];
      if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null){
        this.selectedPlate.processSteps = []
      }
      this.selectedPlate.processSteps.push(newStep)
      this.selectedPlate.status = PlateStatus.STORAGE_PLATE;
    }
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedPlate.plateID,this.selectedPlate,this.selectedLabId).subscribe({
      next: (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.prepareSamplesMap(changeSelectedCell);
        this.onApplyFilter();
        if(statusdata != ""){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
            detail: this.selectedPlate.plateID + ' has been updated successfully!'
          });
        }
      }, error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  tryRemoveProcessingPlateFromStorage(plateID:string){
    let body = {
      "labid":this.selectedLabId,
      "plateid":plateID
    }
    this.blocked = true
    this._maStorageService.removePlateFromStorage(body).subscribe({
      next: (_result) => {
        this.blocked = false
      },
      error: (_error) => {
        this.blocked = false
        this._messagesService.addWarningMessage({
          severity:'warn',summary:`Something went wrong while restoring the plate ${plateID}`
        })
      }
  })
  }

  updateNormalPlate(status, changeSelectedCell: boolean = true){
    if(status != ""){
      var newStep = new Step();
      newStep.step = ProcessStep.RECEIVE_PLATE;
      newStep.startTimeStamp = new Date();
      newStep.startPUID = this.puid;
      newStep.liquidHandler = '';
      newStep.endPUID = "";
      newStep.endTimeStamp = null;
      newStep.action = [];
      newStep.chemicals = [];
      if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null){
        this.selectedPlate.processSteps = []
      }
      this.selectedPlate.processSteps.push(newStep)
      this.selectedPlate.status = PlateStatus.RECEPTION_COMPLETED;
    }
    this.blocked = true;
    this.selectedPlate.reRun = this.selectedPlate.samples.filter(sample => sample.reRunCount >= 1).length >= 1
    this.selectedPlate.priority = this.selectedPlate.reRun ? 0 : this.selectedPlate.samples.reduce((minPriority ,sample) =>  Math.min(minPriority,sample.priority),10)
    this.selectedPlate.dueDate = this.addDueDateToPlate();
    this.platePreparationService.updatePlate(this.selectedPlate.plateID,this.selectedPlate,this.selectedLabId).subscribe({
      next: (result) => {
        this.blocked = false;
        if(this.selectedPlate.status == PlateStatus.RECEPTION_COMPLETED){
          this.tryRemoveProcessingPlateFromStorage(this.selectedPlate.plateID)
          this.performProcessUpdateForWeatherby<Sample>(this.selectedPlate.samples,(sample) => {
              return {
                sampleId:sample._id,
                description: "",
                stageGate : 2,
                status: ProcessUpdateStage.STAGE_GATE
              }
            })
          this.disableSampleType = true;
          this.showPlatePriority = true
        }
        this.selectedPlate = result;
        this.onApplyFilter()
        this.prepareSamplesMap(changeSelectedCell);
        if(status != ""){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
            detail: this.selectedPlate.plateID + ' has been updated successfully!'
          });
        }
      }, error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
  })

  }

  performProcessUpdateForWeatherby<P>(samples:P[], mapper : (sample:P) => SampleData){
    let weatherbySampleDataList = samples.map<SampleData>(mapper)
    let weatherByProcessUpdateDto:ProcessUpdateDTO = {
      data: weatherbySampleDataList,
      labId: this.selectedLabId
    }
    this.announcementService.weatherbyProcessUpdate(weatherByProcessUpdateDto,this.isProcessUpdateProxied).subscribe({
      next: (_result) => {
        this.weatherbySampleDataList = []
      },
      error: (error) => {
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:`Error occurred while sending process update to weatherby.Error: ${error} `
        })
        this.weatherbySampleDataList = []
      }
  })
  }

  showPlateInfo(event) {
    this.searchForPlateAction(event.data.plateID);
  }

  selectSampleFromTable(sample: SamplePlateHistoryDTO) {
    this.selectedPlate.samples.forEach(samp => {
      this.barcodeIDMap.set(samp.sampleID, samp._id)
      this.barcodePositionMap.set(samp.sampleID, samp.position)
    })
    if(this.selectedPlate.plateID != undefined || this.selectedPlate.plateID != null){
      this.selectedSample = new Sample();
      this.selectedSample._id = sample._id
      this.selectedSample.sampleID = sample.sampleId;
      this.blocked = true;
      this.announcementService.getSampleComments(this.selectedLabId, sample._id).subscribe({
        next : (result) => {
          this.blocked = false;
          this.commentList = result.data;
          this.showCommentsDialog = true;
        },
        error: (error: any) => {
          this.blocked = false;
          this._messagesService.addErrorMessage({
            severity: "error", 'summary': "Samples Comments Not Fetched!",
            detail: 'Comments for sample ' + this.selectedSample.sampleID + ' not fetched! \n'+ error
          })
        }
    })
    }
    else
      return;
  }

  getSelectedCellPosition(){
    if(this.selectedPlate.scanHorizontal){
      for(let i=0; i<this.rowHeaders.length; i++){
        for(let j=0; j<this.columnHeaders.length; j++){
          if(!this.positionBarcodeMap.has(this.rowHeaders[i]+ this.columnHeaders[j])){
            this.selectedCell = this.rowHeaders[i]+ this.columnHeaders[j]
            return
          }
        }
      }
    }
    else{
      for(let i=0; i<this.columnHeaders.length; i++){
        for(let j=0; j<this.rowHeaders.length; j++){
          if(!this.positionBarcodeMap.has(this.rowHeaders[j]+ this.columnHeaders[i])){
            this.selectedCell = this.rowHeaders[j]+ this.columnHeaders[i]
            return
          }
        }
      }
    }
  }


  fetchStorageNameForPlate(plateId:string){
    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId,plateId).subscribe({
      next: (storage) => {
        this.blocked = false
        this.selectedPlate.storage = storage.storageName
      },
      error: (_error) => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong!',
          detail:"Error while fetching the storage location"
        })
      }
  })
  }

  sortHistoryPlatesBasedOnPosition(){
    this.selectedPlateHistory.sort((history1, history2) => {
      if(!history1.position){
        return -1;
      }
      if(!history2.position){
        return 1;
      }
      return history1.position.localeCompare(history2.position);
    });
    this.selectedPlateHistory.reverse();
  }

  searchForPlateAction(plateID: string){
    this.blocked = true;
    this.positionBarcodeMap = new Map();
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe({
      next: (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.selectedPlate.samples.forEach(samp => {
          this.positionBarcodeMap.set(samp.position, samp.sampleID)
        })
        this.getSelectedCellPosition();
        this.boxflag = true;
        this.projectData.forEach(project => {
          if(project.sender == this.selectedPlate.sender && project.workflow == this.selectedPlate.workFlow)
            this.selectedProject = project;
        });
        this.fetchBoxDetails(this.selectedPlate.delivery);
        this.scannedBarcode = "";
        this.prepareSamplesMap();
        this.getSelectedSampleType();
        if(this.selectedPlate.storagePlate && this.selectedPlate.status == PlateStatus.STORAGE_PLATE){
          this.fetchStorageNameForPlate(this.selectedPlate.plateID)
        }
        this.selectedSampleType = this.selectedPlate.sampleType.split(",").map(item => item.trim())[this.selectedPlate.sampleType.split(",").map(item => item.trim()).length-1];
        this.selectedPlateType = this.selectedPlate.storagePlate ? PlateType.STORAGE : PlateType.STANDARD;
        this.blocked = true;
        this.getPlateCommentAndUpdatePlateHistory(plateID);

      }, error: (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", "summary":"Plate not found!",
          detail:"Plate not found with plate id - "+plateID
        })
      }
    })
  }

  private getPlateCommentAndUpdatePlateHistory(plateID: string) {
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId, plateID).subscribe({
      next: results => {
        this.blocked = false;
        if (results.comments.length != 0)
          this.plateComment = results.comments[results.comments.length - 1].comment;

        else
          this.plateComment = "";
        this.blocked = true;
        this.announcementService.getPlateHistory(this.selectedLabId, plateID).subscribe({
          next: (result) => {
            this.blocked = false;
            if (result.data != null) {
              this.selectedPlateHistory = result.data.samples;
              this.selectedPlateHistory.sort((a, b) => a.position.localeCompare(b.position));
              this.selectedPlateHistory.reverse();
              this.receivedSamplesInPlateMap.clear();
              this.selectedPlateHistory.forEach(sample => {
                this.receivedSamplesInPlateMap.set(sample.sampleId, true);
              });
            }
          },
          error: (_error: any) => {
            this.blocked = false;
            this.selectedPlateHistory = [];
            this.receivedSamplesInPlateMap.clear();
          }
        });
      },
      error: _error => {
        this.blocked = false;
      }
    });
  }

  fetchBoxDetails(boxId){
    this.blocked = true
    this.deliveryService.validateBox(boxId,this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        let boxDetails = result.data;
        this.selectedBoxID = boxDetails.boxId;
        this.boxStatus = boxDetails.status;
        this.boxProjectID = boxDetails.projectId;
        this.boxReceptionTimeStamp = this.convertToDate(boxDetails.receptionDate);
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error', summary:"Error occured while validating box.",
          detail: error.error
        })
      }
    });
  }

  disableCreateBatchButton(){
    return (this.selectedPlate.labID != null || this.selectedPlate.status!=null)
  }

  searchForPlate() {
    if(!this.plateToSearch || this.plateToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please enter a plateID',
        detail: 'Plate ID cannot be empty, please enter something to search'
      })
      return;
    }
    this.searchForPlateAction(this.plateToSearch);
  }

  searchForSample() {
    if(!this.sampleToSearch && this.sampleToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true;
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.sampleToSearch).subscribe({
      next : (result) => {
        this.blocked = false;
        let sample = result.data[0]
        let sample_id = sample['_id']
        this.blocked = true;
        this.platePreparationService.fetchPlateBySample(sample_id, this.selectedLabId).subscribe({
          next: (result)=>{
            this.blocked = false;
            this._messagesService.addSuccessMessage({
              severity: 'success', detail: 'Sample search success!'
            })
            this.selectedCell = 'A1';
            this.selectedPlate = result;
            this.boxflag = true;
            this.projectData.forEach(project => {
              if(project.sender == this.selectedPlate.sender && project.workflow == this.selectedPlate.workFlow)
                this.selectedProject = project;
            });
            this.scannedBarcode = "";
            this.prepareSamplesMap();
            this.blocked = true;
            this.fetchCommentDetails();
          },
          error: (error)=>{
            this.blocked = false;
            console.log("Error in pulling plate by sample ", error);
            this._messagesService.addErrorMessage({
              severity:"error", "summary":"Plate not found!",
              detail:"Plate not found with sample id - "+this.sampleToSearch
            })
          }
      })
      },
      error: (error: any) => {
        this.blocked = false;
        console.log("Error in pulling plate by sample ", error);
        this._messagesService.addErrorMessage({
          severity:"error", "summary":"Plate not found!",
          detail:"Plate not found with sample id - "+this.sampleToSearch
        })
      }
   })
  }

  fetchCommentDetails() {
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId, this.selectedPlate.plateID).subscribe({
      next: (results) => {
        this.blocked = false;
        if(results.comments.length !=0)
          this.plateComment = results.comments[0].comment;
        else
          this.plateComment = "";
        this.blocked = true;
        this.announcementService.getPlateHistory(this.selectedLabId, this.selectedPlate.plateID).subscribe({
          next : (result)=>{
            this.blocked = false;
            if(result.data != null){
              this.selectedPlateHistory = JSON.parse(result.data).samples;
              this.sortHistoryPlatesBasedOnPosition();
              this.selectedPlateHistory.reverse();
              this.receivedSamplesInPlateMap.clear()
              this.selectedPlateHistory.forEach(sample => {
                this.receivedSamplesInPlateMap.set(sample.sampleId, true);
              })
            }
          },
          error: (error: any) => {
            this.blocked = false;
            this.selectedPlateHistory = [];
            this.receivedSamplesInPlateMap.clear()
            this._messagesService.addErrorMessage({
              severity:"error", "summary":"Plate History not found!",
              detail:"Plate History not found for Plate "+ this.selectedPlate.plateID +" with sample id - "+this.sampleToSearch
            })
          }
        });
      },
      error: (_error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", "summary":"Plate comment not found!",
          detail:"Plate Comment not found for Plate "+ this.selectedPlate.plateID +" with sample id - "+this.sampleToSearch
        })
      }
  })
  }

  clearAllFieldsForNewPlate() {
    this.selectedPlate = new Plate();
    this.selectedProject = null;
    this.plateToSearch="";
    this.sampleToSearch="";
    this.selectedCell = 'A1';
    this.plateSamplesMap = new Map();
    this.sampleBarcodeMap = new Map();
    this.selectedPlateHistory = [];
    this.receivedSamplesInPlateMap = new Map();
    this.plateComment = '';
    this.boxflag = false;
    this.selectedSampleType = '';
    this.selectedPlateType = PlateType.STANDARD;
    this.getSampleTypefromMDM();
    this.disableSampleType = false;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getSampleAt(row: number, col: number) {
    let positionString = this.getRowColStringFromPos(row, col);
    if (this.plateSamplesMap.has(positionString)) {
      return this.plateSamplesMap.get(positionString);
    }
    let sample = new Sample();
    sample.sampleID='';
    return sample;
  }

  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders[row] + this.columnHeaders[col];
  }

  checkSelectedCell(row, col){
    return this.getRowColStringFromPos(row,col) == this.selectedCell
  }

  getSelectedCell(){
    return this.selectedCell;
  }

  selectTableCell(row: number, col: number){
    if(this.selectedPlate.plateID != undefined || this.selectedPlate.plateID != null){
      this.selectedCell = this.getRowColStringFromPos(row, col);
      let selectedCell = this.selectedCell
      this.findAndHighlightElement('barcode-scanner')
      if(this.sampleBarcodeMap.has(selectedCell)){
        this._messagesService.addWarningMessage({
          severity: "warn", summary: "Sample already present",
          detail: "Please choose a different cell"
        })
      }
      else{
        this._messagesService.addWarningMessage({
          severity: "warn", detail:"No Sample in the selected cell!",
        })
        this.commentList = [];
        this.selectedSample = new Sample()
      }
    }
    else
      this.selectedCell = 'A1';
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  closeSampleCheckFailedDialog(){
    this.showSampleCheckFailedDialog = false;
    this.findAndHighlightElement('barcode-scanner');
  }

  prepareSamplesMap(changeSelectedCell: boolean = true){
    this.sampleBarcodeMap.clear();
    this.plateSamplesMap.clear();
    this.selectedPlate.samples.forEach(sample => {
      this.sampleBarcodeMap.set(sample.position,sample.sampleID);
      this.plateSamplesMap.set(sample.position,sample);
    })
    if(this.selectedPlate.samples.length !=0 && this.scannedBarcode != "" && changeSelectedCell)
      this.incrementSelectedCell();
  }

  disableScanCompleteButton(){
    return (this.selectedPlate.plateID == ''
        || this.selectedPlate.workFlow == ''
        || this.selectedPlate.workFlow == null
        || this.selectedPlate.sender == ''
        || this.selectedPlate.sender == null
        || this.selectedPlate.processSteps.length>=1)
  }

  disableCreatePlateButton(){
    return (this.selectedPlate.plateID == '' || this.selectedProject == null || this.selectedPlate.sampleType == null)
  }

  saveComment(){
    this.blocked = true;
    this.announcementService.updateSampleComment(this.selectedLabId, this.selectedSample._id, this.getCommentDTO()).subscribe({
      next : (result) =>{
        this.blocked = false;
        this.newComment = "";
        this.showCommentsDialog = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result.data })
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  getCommentDTO(){
    let newComment = new SampleCommentDTO;
    newComment.puid = this.puid;
    newComment.status = "SAMPLE_RECEPTION";
    newComment.comment = this.newComment;
    return newComment;
  }

  setCommentsDisplay(key,value){
    this.commentsDisplayMap.set(key,value);
  }

  convertToDate(date: Date): Date{
    if (!date || date == null) {
      return;
    }
    return new Date(date);
  }

  validateBoxID(boxID){
    this.blocked = true;
    this.deliveryService.validateBox(boxID,this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        let boxDetails = result.data;
        if (boxDetails === undefined || boxDetails === null) {
          this._messagesService.addErrorMessage({
            severity:"error", "summary":"BoxId not Vaild!",
            detail:"Box ID not found with  "+boxID
          })
          this.selectedPlate.delivery = null;
          return;
        }
        this.selectedBoxID = boxDetails.boxId;
        this.boxStatus = boxDetails.status;
        this.boxflag = true;
        this.boxReceptionTimeStamp = this.convertToDate(boxDetails.receptionDate);
        if (this.selectedProject == null) {
          this.projectData.forEach(project => {
            if (project.projectID == boxDetails.projectId)
              this.selectedProject = project;
          });
        }
        if (this.selectedProject.projectID != null || this.selectedProject.projectID != undefined) {
          if (boxDetails.projectId != this.selectedProject.projectID) {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Box-ID not valid !!!',
              detail: 'Please select the BoxID which has Project ID  : ' + this.selectedProject.projectID,
            });
            this.selectedPlate.delivery = null;
            this.boxflag = false;
            return
          }
        }
        if (boxDetails.status == 'COMPLETED') {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Box-ID not valid !!!',
            detail: 'Box-ID : ' + boxID + ' is COMPLETED',
          });
          this.selectedPlate.delivery = null;
          this.boxflag = false;
          return
        }
        this.boxEmptyPopup = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'ProjectID updated Successful',
          detail: 'Box-ID is valid ',
        });
        if(this.selectedPlate.status){
          this.updateNormalPlate("", false);
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Box-ID not valid !!!',
          detail : error,
        });
      }
    });
  }
  clearBoxID(){
    this.boxEmptyPopup = true;
    this.boxflag = false;
    this.fetchBoxDetails(this.selectedPlate.delivery);
  }

  addPlateToStorage(){
    this.selectedPlateStorage = this.selectedPlateStorage === undefined || this.selectedPlateStorage === null ? this.storageList[0].value : this.selectedPlateStorage;
    if(this.selectedPlate.plateID === '' || this.selectedPlateStorage === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Location Not Selected',
        detail: "Storage location cannot be empty. Please select a storage location."
      });
      return;
    }
    this.blocked = true
    this._maStorageService.searchStorageByPlate(this.selectedLabId, this.selectedPlate.plateID).subscribe({
      next: (result) => {
        this.blocked = false
        let currentPlateLocationInStorage = result.storageName
        if(currentPlateLocationInStorage === this.selectedPlateStorage){
          this._messagesService.addWarningMessage({
            severity:'warn',summary:'Invalid operation',
            detail:`Plate ${this.selectedPlate.plateID} is already in ${result.storageName}. Cannot move to the same location.`
          })
          return
        }
        let plateMigratingData: StoragePlateDTO = {
          labid: this.selectedLabId,
          plateid: this.selectedPlate.plateID,
          storageName: this.selectedPlateStorage,
          oldStorageName: currentPlateLocationInStorage
        };
        this.blocked = true
        this._maStorageService.addPlateToStorage(plateMigratingData).subscribe({
          next: (_result) => {
            this.blocked = false
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: this.selectedPlate.plateID+" added successfully to storage "+this.selectedPlateStorage
            });
            this.showStorageDialog = false;
            return;
          },
          error: (error) => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.statusText
            });
          }
      })
      },
      error: (_error) =>{
        let plateData: StoragePlateDTO = {
          labid: this.selectedLabId,
          plateid: this.selectedPlate.plateID,
          storageName: this.selectedPlateStorage
        };
        this.blocked = true
        this._maStorageService.addPlateToStorage(plateData).subscribe({
          next: (_r) => {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: `${this.selectedPlate.plateID}" added successfully to storage ${this.selectedPlateStorage}`
            });
            this.blocked = false
            this.updateStoragePlate(this.statusdata);

          },
          error: (error) => {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.error
            });
            this.blocked = false
            this.showStorageDialog = false;
          }
      });
        this.showStorageDialog = false;
      }
  })
  }

  closeSamplePresentDialog(){
    this.showSamplePresentDialog = false;
    this.scannedBarcode = '';
    let data = {
      "boxID": this.selectedPlate.delivery,
      "boxReceptionTimeStamp": this.boxReceptionTimeStamp
    }
    this.announcementService.addBoxToSampleSetAside(this.selectedLabId,this.sampleData._id,data).subscribe({
      next: (result) => {
        this._messagesService.addSuccessMessage({
          severity:"success",summary:result.data,
          detail: `Sample ${this.scannedBarcode} has been updated with Box ${this.selectedPlate.delivery}`
        })
      },
      error: (error) => {
        this._messagesService.addErrorMessage({
          severity: "error", summary:"Sample Updated Failed!",
          detail: error
        })
      }
  })
  }

  placeAnnouncedSampleforStorage(){
    this.placeAnnouncedSampletoStorage = true;
    if(this.duplicateSamplesPopUpNormalPlate){
      this.saveBarcodeForNormalPlateAfterDuplicateSelection(this.selectedPickedSample)
    }
    else{
      this.saveBarcodeForStoragePlateAfterDuplicateSelection(this.selectedPickedSample)
    }
  }

  checkWellSample(){
    if(this.sampleBarcodeMap.size != 96){
      this.showPlateNotFilledUpPopup = true;
    }else{
      this.updatePlate(PlateStatus.RECEPTION_COMPLETED);
    }
  }

  goBackCompleteScan(){
    this.showPlateNotFilledUpPopup = false;
  }

  boxEmptyCheck(){
    this.boxEmptyPopup = true;
  }

  updateBoxStatus(boxId, status){
   let searchDelivery = new SearchDelivery();
   searchDelivery.boxId = boxId;
   searchDelivery.labId = this.selectedLabId;
   searchDelivery.status = status;
   searchDelivery.projectId = this.boxProjectID;
   this.blocked = true;
   this.deliveryService.updateBoxIdStatus(searchDelivery).subscribe({
     next: (_result) => {
      this.blocked = false;
     },
     error: (error) => {
       this.blocked = false;
       this.boxEmptyPopup = false;
       this._messagesService.addErrorMessage({
         severity: 'error', summary: 'Box-ID not valid !!!',
         detail : error,
       });
     }});
     this.selectedPlate.delivery = null;
     this.boxEmptyPopup = false;
  }

  updateSampleforPlate(){
    this.selectedPlate.sampleType = this.selectedPlate.sampleType!=undefined && this.selectedPlate.sampleType!=null ? this.selectedPlate.sampleType+","+[this.selectedSampleType].join(",") :[this.selectedSampleType].join(",");
    if(this.selectedPlate.status == "PLATE_CREATED"){
      this.updateNormalPlate("", false);
    }
  }

  showUnsuitableSampleDialog(){
    this.unsuitableDialog = true
    this.enteredUnsuitableSampleId = ''
    this.multiUnsuitableSampleList = []
  }

  onChecked(event:any){
    this.disableSampleInput = event.checked;
    this.selectedRedoReason = ''
    this.disableUpdateButton = !event.checked
    this.multiUnsuitableSampleList = []
  }

  addToUnsuitableList(){
    if(this.duplicateSampleForUnsuitable){
      this.duplicateSampleForUnsuitable = false
      this.setDuplicateSamplesPopUp()
    }
    if(this.enteredUnsuitableSampleId === '' || this.enteredUnsuitableSampleId === undefined){
      this._messagesService.addWarningMessage({
        severity:'warn',summary:'No sample scanned',
        detail:"Please scan a sample to process forward"
      })
    }

    if(this.multiUnsuitableSampleList.filter(x => x.barcode === this.enteredUnsuitableSampleId).length === 1){
      this._messagesService.addWarningMessage({
        severity:'warn',summary:'Sample already present'
      })
      return
    }
    if(this.multiUnsuitableSampleList.length >= 20){
      this._messagesService.addWarningMessage({
        severity:'warn',summary:'Maximum limit reached',
        detail:'20 samples can be marked as unsuitable at a time'
      })
      return
    }
    if(!this.selectedRedoReason || this.selectedRedoReason === ''){
      this.disableUpdateButton = true
    }
    this.blocked = true
    this.announcementService.getSampleFromDelivery(this.selectedLabId,this.enteredUnsuitableSampleId).subscribe({
      next : (samples) => {
        this.blocked = false
        this.allSelectedSamples = samples.data
        if(this.allSelectedSamples.length > 1){
          this.duplicateSampleForUnsuitable = true
          this.setDuplicateSamplesPopUp()
          return
        }
        const sample = this.allSelectedSamples[0] as Sample;
        if(!sample.announced){
          this._messagesService.addErrorMessage({
            severity:'error',summary:'Unannounced Sample scanned!',
            detail:`This given sample ${this.enteredUnsuitableSampleId} is an unannounced sample.Please wait for it's announcement and then try again.`
          });
          return;
        }
        if(sample.receptionStatus && sample.receptionStatus === "REMOVED"){
            this.sampleCheckErrorMessage = `Sample ${this.scannedBarcode} is already marked as unsuitable with the reason ${sample.receptionIssueReason}`;
            this.showSampleCheckFailedDialog = true;
            return;
        }
        this.blocked = true
        this.platePreparationService.checkSamplePresentInPlate(this.selectedLabId,this.allSelectedSamples[0]._id).subscribe({
          next: (result) => {
            this.blocked = false
            if(result.present){
              this._messagesService.addWarningMessage({
                severity: 'warn', summary: 'Invalid Barcode',
                detail: "Barcode: '"+this.enteredUnsuitableSampleId +"' is already scanned in Plate "+ result.plateID +". Please scan a different barcode.",
              });
              this.enteredUnsuitableSampleId = ''
              this.findAndHighlightElement('unsuitable-sample-id')
              return
            }
            this.multiUnsuitableSampleList.push({"id":this.allSelectedSamples[0]._id,"barcode":this.enteredUnsuitableSampleId})

            this.enteredUnsuitableSampleId = ''
            this.findAndHighlightElement('unsuitable-sample-id')
          },
          error: (_error) => {
            this._messagesService.addErrorMessage({
              severity:'error',summary:'Something went wrong',
              detail:'Something went wrong while checking the sample.Please try again'
            })
            this.enteredUnsuitableSampleId = ''
            this.findAndHighlightElement('unsuitable-sample-id')
            return
          }
      })
      },
      error: (error: any) => {
        this.blocked = false
        this.sampleCheckErrorMessage = "Sample " + this.scannedBarcode + " was not announced in the manifest for project "+this.selectedProject.projectID
        this.showSampleCheckFailedDialog = true;
      }
    })
  }

  addDuplicateSampleToList(sampleId:string){
    this.blocked = true
    this.platePreparationService.checkSamplePresentInPlate(this.selectedLabId,sampleId).subscribe({
      next: (result) => {
        this.blocked = false
        if(result.present){
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid Barcode',
            detail: "Barcode: '"+this.enteredUnsuitableSampleId +"' is already scanned in Plate "+ result.plateID +". Please scan a different barcode.",
          });
          this.enteredUnsuitableSampleId = ''
          this.findAndHighlightElement('unsuitable-sample-id')
          return
        }
        this.multiUnsuitableSampleList.push({"id":sampleId,"barcode":this.enteredUnsuitableSampleId})

        this.enteredUnsuitableSampleId = ''
        this.findAndHighlightElement('unsuitable-sample-id')
        if(this.duplicateSampleForUnsuitable){
          this.duplicateSampleForUnsuitable = false
          this.setDuplicateSamplesPopUp()
        }
      },
      error: (_error) => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:'Something went wrong while checking the sample.Please try again'
        })
        this.enteredUnsuitableSampleId = ''
        this.findAndHighlightElement('unsuitable-sample-id')
        return
      }
  })
  }

  closeUnsuitableDialog(){
    this.multiUnsuitableSampleList = []
    this.disableSampleInput = false
    this.unsuitableDialog = false
    this.weatherbySampleDataList = []
    this.disableUpdateButton = true
    this.isBarcodeNotReadableChecked = false
    this.announcementService.getPlateHistory(this.selectedLabId, this.selectedPlate.plateID).subscribe({
      next:(result)=>{
        this.blocked = false;
        if(result.data != null){
          this.selectedPlateHistory = result.data.samples;
          this.sortHistoryPlatesBasedOnPosition();
          this.selectedPlateHistory.reverse();
          this.receivedSamplesInPlateMap.clear()
          this.selectedPlateHistory.forEach(sample => {
            this.receivedSamplesInPlateMap.set(sample.sampleId, true);
          })
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.selectedPlateHistory = [];
        this.receivedSamplesInPlateMap.clear()
      }
    });

  }
  removeSampleFromList(index:number) {
    this.multiUnsuitableSampleList.splice(index,1)
    if(this.multiUnsuitableSampleList.length === 0){
      this.disableUpdateButton = true
    }
  }
  onOptionSelected(event:any){
    if(this.disableUpdateButton && this.multiUnsuitableSampleList.length > 0){
      this.disableUpdateButton = false
    }

    if(event.value === null){
      this.selectedRedoReason = ''
      this.disableUpdateButton = true
    }
  }

  addUnsuitableSample(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please enter USER ID before moving ahead',
      });
      return;
    }
    if(this.disableSampleInput){
      this.createNewUnannoucedSample("Sample not scannable","",false,(sample) => {
        this._messagesService.addSuccessMessage({
          severity:'success',summary:'Unsuitable sample created succesfully',
          detail:`Unsuitable sample with id ${sample._id} is created successfully`
        })
        this.closeUnsuitableDialog()
      })
      return
    }
    const body = {
      'sampleIds':this.multiUnsuitableSampleList.map(samples => samples.id),
      'plateId':this.selectedPlate.plateID,
      'redoReason':this.selectedRedoReason
    }

    this.blocked = true
    this.announcementService.addUnsuitableSamples(this.selectedLabId,body).subscribe({
      next: (_result) => {
        this.blocked = false
        this._messagesService.addSuccessMessage({
          severity:"success",summary:'Sample updation success',
          detail:`${this.multiUnsuitableSampleList.length} samples have been marked as unsuitable`
          })
          this.performProcessUpdateForWeatherby<any>(this.multiUnsuitableSampleList,(sample) => {
            return {
              sampleId:sample.id,
              description:body["redoReason"],
              stageGate : null,
              status: ProcessUpdateStage.UNSUITABLE
            }
          })
          this.closeUnsuitableDialog()
      } ,
      error: (_error) => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:`Something went wrong while marking ${this.multiUnsuitableSampleList.length} samples as unsuitable.Please try again`
        })
        this.closeUnsuitableDialog()
      }
  })
  }

  getRedoSampleCount(){
    this.blocked = true;
    this.platePreparationService.getRedoSampleCount(this.selectedLabId).subscribe({
      next:(result)=>{
        this.blocked = false;
        if(result != null){
          this.numberOfRedoSamples = result;
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:`Something went wrong while loading number of Redo Samples.Please try again`
        })
        this.numberOfRedoSamples = 0;
      }
    })
  }

  downloadRedoSamplesFile(){
    this.blocked = true;
    let data = new SampleRedoDownloadDTO();
    data.labId = this.selectedLabId;
    data.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.platePreparationService.downloadRedoSamplesList(data).subscribe({
      next: (res) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Redo Samples File Generated Successfully',
        });
        let blob = new Blob([res.fileContent], { type: res.fileContent.type });
        console.log("File name : " + res.filename);
        saveByFileSaver(blob, res.filename);
      },error: (error) => {
        this.blocked = false;
        if(error.status == 404){
          this._messagesService.addErrorMessage({
            severity: 'warn',detail: "No samples to redo!"
          });
        }
        else if(error.status == 409){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Error',
            detail: "Error occured while generating file for redo samples"
          });
        }
      }
  })
  }

  getPriorityClass(priority:number){
    return priorityMap[priority]
  }

  determineClassForDifferentSampleBarcodes(i,j){
    let sampleAtPosition = this.getSampleAt(i,j);
    let isSelectedCell = this.checkSelectedCell(i,j);
    if(isSelectedCell){
      return "selected-cell";
    }
    else if(!isSelectedCell && sampleAtPosition.sampleID != '' && !sampleAtPosition.reProcessed){
      return "cell-with-value";
    }
    else if(!isSelectedCell && sampleAtPosition.sampleID != '' && sampleAtPosition.reProcessed){
      return "cell-with-value-processed";
    }
    else if(!isSelectedCell && sampleAtPosition.sampleID == ''){
      return "";
    }
    else{
      return "";
    }
  }

  convertUtcToLocal(date: Date){
    if(!date) {
      return null
    }
    const offset = new Date().getTimezoneOffset();
    const dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  checkIfSampleIsDisabledForSelection(sample: Sample): boolean {
      return sample.receptionStatus === "REMOVED" || sample.sampleCompletionDate !== null;
  }

  checkStatusChange(plate: Plate): boolean{
    return plate?.lastModifiedDate === plate?.adminChangeTimeStamp;
  }
}
